import { render, staticRenderFns } from "./SupportChat.vue?vue&type=template&id=18e56c35&scoped=true&"
import script from "./SupportChat.vue?vue&type=script&lang=js&"
export * from "./SupportChat.vue?vue&type=script&lang=js&"
import style0 from "./SupportChat.vue?vue&type=style&index=0&id=18e56c35&lang=sass&rel=stylesheets%2Fsass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e56c35",
  null
  
)

export default component.exports